import {IStateService} from 'angular-ui-router';
import {SerfPropertyRS} from '../../../admin/service/serfPropertyRS.rest';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import ZahlungsauftragRS from '../../../core/service/ZahlungsauftragRS.rest';
import {TSAnlaufstelleType} from '../../../models/enums/TSAnlaufstelleType';
import {
    beitragArtPrefix,
    beitragPropertySuffix,
    getDefaultTSBeitragArtValues,
    getTSBeitragArtSchadenfallValues,
    getTSBeitragArtValuesByYear,
    TSBeitragArt,
} from '../../../models/enums/TSBeitragArt';
import {TSBeitragStatus} from '../../../models/enums/TSBeitragStatus';
import {TSKantonCode} from '../../../models/enums/TSKantonCode';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import TSBankverbindung from '../../../models/TSBankverbindung';
import TSBeitrag from '../../../models/TSBeitrag';
import TSGemeinde from '../../../models/TSGemeinde';
import TSGesuchsPersonDaten from '../../../models/TSGesuchsPersonDaten';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSSerfProperty from '../../../models/TSSerfProperty';
import TSZahlungsauftragDTO from '../../../models/TSZahlungsauftragDTO';
import DVBernUtil from '../../../utils/DVBernUtil';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./beitragView.html');

export class BeitragEditViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BeitragViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        beitrag: '<',
        schadenfall: '<',
    };
}

export class BeitragViewController extends AbstractModelManagerController<TSBeitrag> {

    beitrag: TSBeitrag;
    form: IFormController;
    schadenfall: TSSchadenfall;
    prozentsatzArray: Map<string, number> = new Map();      //array das kein array ist? -> map machen
    kanton: TSKantonCode;
    prozentsatz: number | undefined;
    betragVorschlag: number;
    anrechenbarerschaden: number;
    serfProperties: Array<TSSerfProperty>;
    readonly: boolean = false;
    zahlungsauftrag: TSZahlungsauftragDTO;

    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state', 'SerfPropertyRS', 'ZahlungsauftragRS'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private serfPropertyRS: SerfPropertyRS, private zahlungsauftragRS: ZahlungsauftragRS,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);

    }

    $onInit() {
        super.$onInit();
        this.schadenfallModelManager.openSchadenfall(this.schadenfall.id);

        if (!this.beitrag) {
            this.beitrag = new TSBeitrag();
            this.$log.warn('initialized beitrag to edit directly in view, should pass beitrag to edit along');
        } else {
            this.initialModel = this.beitrag;
            this.model = angular.copy(this.beitrag);
        }

        if (this.beitrag.id) {
            this.readonly = true;
            if (this.beitrag.beitragStatus === TSBeitragStatus.AUSGEFUEHRT) {
                this.zahlungsauftragRS.getZahlungsauftraegeForBeitrag(this.beitrag.id).then((response: TSZahlungsauftragDTO) => {
                    this.zahlungsauftrag = response;
                });
            }
        }

        this.extractKanton();
        this.prepareProzentsatzMap();
    }

    public prepareProzentsatzMap(): void {
        getTSBeitragArtSchadenfallValues().forEach((art) => {
            //Konstruiert den Search String, falls Kanton wird der Kantons kürzel verwendet anstatt KANTON
            let key: string = art.toString();
            let searchString: string = (art === TSBeitragArt.KANTON ? this.kanton.toString() : key) + beitragPropertySuffix();
            this.serfPropertyRS.getByName(searchString).then((serfProperty: TSSerfProperty) => {
                if (serfProperty && serfProperty.value) {
                    this.prozentsatzArray.set(key, parseFloat(serfProperty.value));
                    this.updateBeitragArt();
                }
            });
        });
    }

    public extractKanton(): void {
        let anlaufstelle = this.schadenfall.anlaufstelle;
        let tmpKanton: TSKantonCode | undefined;
        if (anlaufstelle) {
            switch (anlaufstelle.anlaufstelleType) {
                case TSAnlaufstelleType.KANTON:
                    tmpKanton = anlaufstelle.kanton;
                    break;
                case TSAnlaufstelleType.GEMEINDE:
                    this.checkAllGemeindenHaveSameKanton(anlaufstelle);
                    tmpKanton = anlaufstelle.gemeinden[0].kanton;
                    break;
            }
            if (tmpKanton) {
                this.kanton = tmpKanton;
            }
        }
    }

    /**
     * pruefe dass alle gemeinden den gleichen kanton haben
     */
    private checkAllGemeindenHaveSameKanton(anlaufstelle: TSAnlaufstelle) {
        if (!anlaufstelle || anlaufstelle.gemeinden === undefined || anlaufstelle.gemeinden.length === 0) {
            this.$log.error('anlaufstelle must have gemeinden if it has type gemeinde', anlaufstelle);
            throw new Error('Illegal State, anlaufstelle should be defined and have assigned at least one gemeinde')
        }
        let tmpGemeinden: Array<TSGemeinde> = anlaufstelle.gemeinden;
        let tmpgemeindekanton = tmpGemeinden[0].kanton;
        let kantonConflict: boolean = false;
        tmpGemeinden.forEach(function (gemeinde) {

            if (tmpgemeindekanton !== gemeinde.kanton) {
                kantonConflict = true;
            }
        });
        if (kantonConflict) {
            this.$log.warn('Not all Gemeinden share the same Kanton!\nThis must not happen!\nContinue'
                + ' using Kanton of first Gemeinde of anlaufstelle.gemeinden', tmpGemeinden);
        }
    }

    public saveBeitrag() {
        if (this.isModelValid() && this.beitrag) {
            this.schadenfallModelManager.saveBeitrag(this.getModel()).then(() => {
                this.$state.go('entschaedigung', {schadenfallId: this.schadenfall.id})
            });
        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelBeitrag() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.$state.go('entschaedigung', {schadenfallId: this.schadenfall.id})

    }

    public getAvailableTSBeitragArtValues(): Array<TSBeitragArt> {
        const date = this.schadenfall.schaeden[0].schadenDatenFS.schadendatum;
        return date ? getTSBeitragArtValuesByYear(date!.year()) : getDefaultTSBeitragArtValues();
    }

    public translateBeitragArt(art: TSBeitragArt): string {
        let prefix = beitragArtPrefix();
        return this.$translate.instant(prefix + TSBeitragArt[art])
    }

    public getModel(): TSBeitrag {
        return this.beitrag;
    }

    public getBankVerbindung(): TSBankverbindung {
        if (this.beitrag.bankverbindung) {
            return this.beitrag.bankverbindung;
        }
        return this.schadenfall.gesuchsteller.finanzangaben!.finanzangabenDatenFS.bankverbindung!; // bei erstperson sind finanzangaben da
    }

    public getGesuchsteller(): TSGesuchsPersonDaten | undefined {
        let gesuchsteller = this.schadenfall.gesuchsteller.kontaktperson;
        if (gesuchsteller) {
            return gesuchsteller.gesuchsPersonDatenFS;
        }
        return new TSGesuchsPersonDaten();
    }

    public updateBeitragArt(): void {
        if (this.getModel().beitragArt) {
            this.prozentsatz = this.prozentsatzArray.get(this.getModel().beitragArt.toString());
            this.betragVorschlag = parseFloat(this.schadenfall.getAnrechenbarerSchaden(this.prozentsatz).toFixed(2));
            this.betragVorschlag = Math.max(this.betragVorschlag, 0); //vorschlag kann nicht kleiner 0 sein
            if (!this.readonly) {
                this.beitrag.beitrag = this.betragVorschlag;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/beitragView/beitragView.ts